export default __webpack_public_path__ + "static/Layer_5-ba687396d482a43c430de54d98324cdf.png";